// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6415) return "static/chunks/6415-d75234f20b9ff6af.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"337":"49788208d4aba125","2875":"6d95cda3df23bcd0","4486":"e8610923315c76da"}[chunkId] + ".js";
};